/**
 * Timeout enter
 * @param {CustomEventProps} event
 */
const timeoutenter = (event) => {};

export default timeoutenter;
